import { render, staticRenderFns } from "./index.vue?vue&type=template&id=350b16b0&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350b16b0')) {
      api.createRecord('350b16b0', component.options)
    } else {
      api.reload('350b16b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=350b16b0&", function () {
      api.rerender('350b16b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/info/rate-fraud-free/index.vue"
export default component.exports